import { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import { useSportConfiguration } from "~hooks/useSportConfiguration.ts";
import type { LabelValue } from "~types/labelValue.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  defaultValue?: string | { value: string; label: string }[];
  placeholder?: string;
  multiple?: boolean;
  value?: LabelValue | LabelValue[];
  onChange?: (value: LabelValue | LabelValue[] | undefined) => void;
};

const SelectEntityStandard = (props: Props) => {
  const { className, disabled, defaultValue, multiple } = props;
  const { entityStandards } = useSportConfiguration();

  const options = useMemo(
    () =>
      Object.values(entityStandards).map((value) => ({
        value,
        label: value,
      })),
    [entityStandards],
  );

  return (
    <CustomSelect
      style={{ minWidth: "110px" }}
      value={props.value}
      defaultValue={defaultValue}
      onChange={(_, option) => {
        if (multiple) {
          props.onChange?.(option as { value: string; label: string }[]);
        } else {
          props.onChange?.(option as { value: string; label: string });
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="standard" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default SelectEntityStandard;
